import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useApi from '../api';
import { Separator } from '@/components/ui/separator';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Service } from '../services/servicesShared';
import JobsList from './JobsList';
import NeedsYou from './NeedsYou';

/** /jobs — every job across services, plus the Needs-you queue. */
const JobsPage: React.FC = () => {
    const { get } = useApi();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') === 'needs-you' ? 'needs-you' : 'jobs';
    const [services, setServices] = useState<Service[]>([]);

    useEffect(() => {
        get('/services/')
            .then((response) => setServices(response.data?.data || []))
            .catch((error) => console.error('Error fetching services:', error));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setTab = (tab: string) => {
        const params = new URLSearchParams(searchParams);
        if (tab === 'jobs') params.delete('tab');
        else params.set('tab', tab);
        setSearchParams(params);
    };

    return (
        <div className="p-12 overflow-y-auto max-h-[calc(100vh-1px)] scrollbar-thin grow">
            <div>
                <h1 className="text-4xl font-bold">Jobs</h1>
                <p className="mt-4 text-sm text-slate-500">
                    One job per customer per service: the work the AI owns and keeps doing. Open a job for its state, action log,
                    steering channel and wakes.
                </p>
            </div>
            <Separator className="my-4" />
            <Tabs value={activeTab} onValueChange={setTab}>
                <TabsList>
                    <TabsTrigger value="jobs">All jobs</TabsTrigger>
                    <TabsTrigger value="needs-you">Needs you</TabsTrigger>
                </TabsList>
                <TabsContent value="jobs" className="mt-4">
                    <JobsList active={activeTab === 'jobs'} services={services} />
                </TabsContent>
                <TabsContent value="needs-you" className="mt-4">
                    <NeedsYou active={activeTab === 'needs-you'} />
                </TabsContent>
            </Tabs>
        </div>
    );
};

export default JobsPage;
